module.exports = __webpack_public_path__ + "static/media/light-02.c0f6276e.jpg";